<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <v-radio-group row v-model="radio" :rules="[validateRequired]" :disabled="disabled">
    <template v-for="(option, index) in options">
      <template v-if="option != 'その他'">
        <v-radio
          class="normal-radio"
          :key="index"
          :label="option"
          :value="option"
          style="display: flex"
        >
        </v-radio>
      </template>
      <template v-else>
        <v-row class="other-radio" :key="index" style="margin-left: 0px">
            <v-radio
              :value="otherTextValue"
              style="display: flex"
            >
            </v-radio>
            <v-text-field
              :placeholder="option"
              v-model="otherTextValue"
              @input="handleRadioChange"
            >
            </v-text-field>
        </v-row>
      </template>
    </template>
  </v-radio-group>
</template>

<script>
import Vue from "vue";
import InputBase from "./InputBase.vue";
import { isBlank } from "../utils/validationUtils";

export default Vue.extend({
  name: "InputChoice",
  mixins: [InputBase],
  props: {
    isLiffMode: Boolean,
    isAdminMode: Boolean,
  },
  data() {
    return {
      otherTextValue: '',
    };
  },
  computed: {},
  created() {
    var params = Object.assign(
      {
        options: [],
        isRequired: { value: false, admin: null },
        isRequiredForUser: { value: false },
        input: undefined,
      },
      this.params
    );

    this.itemKey = this.params.itemKey;
    this.options = params.options;
    this.required = params.isRequired.value;
    this.isRequiredForUser = params.isRequiredForUser.value;

    if (this.isAdminMode) {
      if ("admin" in params.isRequired) {
        if (params.isRequired.admin === null) {
          params.isRequired.admin = params.isRequired.value;
        }
        this.required = params.isRequired.admin;
      }
    }

    this.radio = params.input;
  },
  methods: {
    getValue() {
      return this.radio;
    },
    validateRequired() {
      const isValid = !isBlank(this.radio);
      if (this.isAdminMode) {
        return !this.required || isValid;
      } else if (this.isLiffMode) {
        return (!this.required && !this.isRequiredForUser) || isValid;
      }
    },
    handleRadioChange() {
      if (this.otherTextValue === "") {
        this.radio = "";
      } else {
        this.radio = this.otherTextValue;
      }

      // if (this.otherTextValue === this.radio) {
      //   this.otherTextValue = "";
      // }
    }
  },
});
</script>
<style scoped>
.v-input--radio-group.v-input--radio-group--row .v-radio {
    margin-right: 3px;
}
.v-input--radio-group.v-input--radio-group--row .normal-radio {
    margin-top: 5px;
}
</style>
